import React from 'react'
import { Table, Collapse } from 'antd'
import { getDomainFromShop } from '../../../../utils'

const statusColors = {
  new_product: '#6c6f00',
  selling: '#2e7d32',
  notavailable: '#d32f2f',
  descatalogued: '#707070',
  invalid: '#707070',
  discontinued: '#707070',
}

export default function Options({ product }) {
  const options = Object.values(product.opciones || {})
  const optionsByRef = groupBy(options, 'referencia')
  const refs = unify(
    options.sort((a, b) => b.anyada - a.anyada).map((a) => a.referencia)
  )

  function getHeader(ref) {
    const [first] = optionsByRef[ref]
    return (
      <>
        {first.anyada && (
          <span>
            <b>Year: </b>
            {first.anyada}{' '}
          </span>
        )}
        {first.capacidad && (
          <span>
            <b>Capacity: </b>
            {first.capacidad}{' '}
          </span>
        )}
        {(first.anyada || first.capacidad) && ' - '}
        <i>{ref}</i>
      </>
    )
  }

  return (
    <Collapse defaultActiveKey={[refs[0]]}>
      {refs.map((ref) => (
        <Collapse.Panel header={getHeader(ref)} key={ref}>
          <Table
            dataSource={optionsByRef[ref]}
            pagination={false}
            columns={[
              {
                title: 'Country',
                dataIndex: 'country',
                width: 30,
                render: (country, line) => (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`https://${getDomainFromShop(
                      line.shop
                    )}/administracion/contenidos/edicion_producto.html?id_producto=${ref}`}
                  >
                    {country}
                  </a>
                ),
              },
              {
                title: 'State',
                dataIndex: 'estado',
                width: 30,
                render: (v) => (
                  <Box color={statusColors[v]}>{v.toUpperCase()}</Box>
                ),
              },
              {
                title: 'Price',
                dataIndex: 'precio_sin_impuestos',
                width: 30,
                render: (v) => v.toFixed(2) + ' €',
              },
              {
                title: 'Offer',
                dataIndex: 'oferta',
                width: 30,
                render: (v) =>
                  v &&
                  v.precio_oferta && (
                    <Box color="#c43e00">
                      {v.precio_oferta.toFixed(2) + ' €'}
                    </Box>
                  ),
              },
              {
                title: 'P.IVA',
                dataIndex: 'precio_sin_impuestos',
                width: 30,
                render: (v, line) => (v + v * line.impuestos).toFixed(2) + ' €',
              },
              {
                title: 'Prov',
                dataIndex: 'proveedor',
                width: 30,
              },
              {
                title: 'Last units',
                dataIndex: 'ultimas_unidades',
                width: 30,
                render: (v) => v.toString(),
              },
            ]}
            rowKey={(record) => record.index}
            size="small"
          />
        </Collapse.Panel>
      ))}
    </Collapse>
  )
}

function Box({ color, children }) {
  return (
    <span
      style={{
        backgroundColor: color,
        color: 'white',
        borderRadius: 2,
        padding: 5,
        fontSize: 12,
      }}
    >
      {children}
    </span>
  )
}

function groupBy(xs, key) {
  return xs.reduce((rv, x) => {
    ;(rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}

function unify(array) {
  return [...new Set(array)]
}
